// extracted by mini-css-extract-plugin
module.exports = {"container":"twoColsComponent_container__32VjI","light":"twoColsComponent_light__2aWHl","dark":"twoColsComponent_dark__iaPyR"};
    if(module.hot) {
      // 1790670292455
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  